import { Dispatch, SetStateAction } from 'react';
import { Desktop, Mobile } from '../../../App';
import {
  BACKOFFICE_NAME,
  USDT,
  dateDifferenceInDaysFromToday
} from '../../../helpers/helperFunctions';
import { CaptionText, H2, H3, H4, P1, P3 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';

import { Checkbox } from '../Checkbox/Checkbox';

import { useTranslation } from 'react-i18next';
import { VirtualOfficeSubscriptionStyled } from './VirtualOfficeSubscription.styled';
import moment from 'moment';
import { useAppSelector } from '../../../app/hooks';

interface VirtualOfficePlanProps {
  selected: any;
  setSelected: Dispatch<SetStateAction<any>>;
  licences: any;
}

export const VirtualOfficePlan = ({
  selected,
  setSelected,
  licences
}: VirtualOfficePlanProps) => {
  const { t } = useTranslation('settings');

  return (
    <div>
      <P1 bold mb='20' mt='10' caps>
        Add {BACKOFFICE_NAME} SUBSCRIPTION:
      </P1>
      {licences?.map((plan: any, i: number) => (
        <VirtualOfficeSubscriptionStyled
          key={i}
          onClick={() =>
            setSelected((current: any) =>
              current?.id === plan.id ? null : plan
            )
          }>
          <div style={{ width: '100%' }}>
            <Flexed between>
              <Flexed center>
                <Checkbox
                  margin='0 20px 0 0'
                  size='38'
                  onChange={(checked) => setSelected(checked ? plan : null)}
                  checked={selected?.id === plan.id}
                  checkColor={colors.primary900}
                />
                <div>
                  <H4>{plan.name}</H4>
                  {plan?.id === 6 && (
                    <P3 bold>
                      Ends {moment(plan?.offerEndDate).format('DD MMM YYYY')} ·{' '}
                      {dateDifferenceInDaysFromToday(plan?.offerEndDate)} days
                      left
                    </P3>
                  )}
                  {plan?.id === 7 && (
                    <P3 bold>
                      Ends {moment(plan?.offerEndDate).format('DD MMM YYYY')} ·{' '}
                      {dateDifferenceInDaysFromToday(plan?.offerEndDate)} days
                      left
                    </P3>
                  )}
                  <P3>{plan?.name2}</P3>
                </div>
              </Flexed>
              <Flexed alignEnd column>
                <Desktop>
                  <H2>
                    {plan.price} {USDT}
                  </H2>
                </Desktop>
                <Mobile>
                  <H3>
                    {plan.price} {USDT}
                  </H3>
                </Mobile>

                {plan.save && (
                  <CaptionText bold color={color.colors.success500}>
                    {t('virtual_office.plans.save')} {plan.save}%
                  </CaptionText>
                )}
              </Flexed>
            </Flexed>
          </div>
        </VirtualOfficeSubscriptionStyled>
      ))}
    </div>
  );
};
